<template>
  <g>
    <path
      d="M17.9213 9.94066H16.8653V9.40733C16.8653 7.54066 17.9533 6.23933 19.5106 6.23933V4.66066H13.6973C11.4573 4.66066 10.5293 5.02333 10.5293 7.30599H11.5853C12.972 7.30599 13.6973 8.04199 13.6973 9.41799V9.95133H12.6306V9.41799C12.6306 8.60733 12.3853 8.36199 11.5746 8.36199H9.46265V7.29533C9.46265 3.88199 11.5533 3.59399 13.6973 3.59399H20.5666V7.29533H19.5106C18.3373 7.29533 17.9213 8.43666 17.9213 9.40733V9.94066Z"
      :fill="iconColor"
      :stroke="iconColor"
      stroke-width="0.75"
      stroke-miterlimit="10"
      stroke-linejoin="round"
    />
    <path
      d="M21.7509 7.29711H21.0896V6.24111H21.4949L22.1563 5.92111V4.98245L21.4949 4.66245H21.0896V3.60645H21.7509L23.2123 4.33178V6.57178L21.7509 7.29711Z"
      :fill="iconColor"
      :stroke="iconColor"
      stroke-width="0.75"
      stroke-miterlimit="10"
    />
    <path
      d="M22.6781 14.1768C22.5714 14.1768 22.4754 14.1447 22.3794 14.0807C19.6594 12.2247 18.9661 9.65408 18.9448 9.54742C18.8701 9.25942 19.0408 8.97142 19.3288 8.90742C19.6168 8.83275 19.8941 9.00342 19.9688 9.29142C19.9794 9.33408 20.6088 11.6061 22.9768 13.2168C23.2221 13.3768 23.2861 13.7074 23.1154 13.9527C23.0194 14.1021 22.8488 14.1768 22.6781 14.1768Z"
      :fill="iconColor"
      :stroke="iconColor"
      stroke-width="0.75"
      stroke-miterlimit="10"
    />
    <path
      d="M17.922 12.2352H16.866V10.6458H13.698V12.2352H12.6313V9.58984H17.922V12.2352Z"
      :fill="iconColor"
      :stroke="iconColor"
      stroke-width="0.75"
      stroke-miterlimit="10"
    />
    <path
      d="M20.2357 28.4469H8.9397V27.9136C8.9397 22.7402 8.9397 15.6469 12.8117 12.1909L12.961 12.0522H17.537L17.665 12.1269C18.3157 12.5216 19.4037 13.1829 19.4997 14.6549C19.5317 15.1989 19.4144 15.5722 19.2864 15.9776C19.137 16.4149 18.977 16.9162 18.977 17.8656C18.977 18.3669 19.3184 18.7189 19.9264 19.3056C20.865 20.2122 22.145 21.4496 22.145 24.2122C22.145 26.7082 20.449 28.2442 20.385 28.3082L20.2357 28.4469ZM9.9957 27.3909H19.8197C20.1717 27.0176 21.0997 25.8549 21.0997 24.2229C21.0997 21.9082 20.0864 20.9376 19.201 20.0736C18.5504 19.4442 17.921 18.8469 17.921 17.8762C17.921 16.7562 18.1237 16.1482 18.2837 15.6576C18.401 15.3056 18.4757 15.0816 18.4544 14.7402C18.401 13.9296 17.8997 13.5242 17.2384 13.1189H13.3664C10.113 16.2122 9.9957 22.5482 9.9957 27.3909Z"
      :fill="iconColor"
      :stroke="iconColor"
      stroke-width="0.75"
      stroke-miterlimit="10"
      stroke-linejoin="round"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#ee1c25"
    }
  }
};
</script>
